import "../styles/cardStyles.css";
import {Clock, Mail, Shield} from "lucide-react"
import React from "react";


function CommonReasonsCard() {
  return (
    <div className="card w-full max-w-sm border rounded-xl bg-white px-4 py-4 shadow-xl">
      <div className="cardHeader px-4">
        <Shield className="cardHeader__icon text-amber-600"/>
        <h3 className="text-2xl font-semibold">Common Reasons</h3>
      </div>
      <p className="text-sm text-slate-500 px-4">Why websites get temporarily removed</p>
      <ul className="cardList bulletedList text-slate-600">
        <li>Account suspension due to policy violations</li>
        <li>Billing or payment issues</li>
        <li>Security concerns ir malware detection</li>
        <li>Resource usage limits exceeded</li>
        <li>Maintenance or server migration</li>
      </ul>
    </div>
  )
}

export default CommonReasonsCard;